import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';

import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { getFormMapping } from '@/core/config/viewMapping/GeneralFormMapping';

import { Endpoints } from '@/api/ApiEndpoints';

@Module
export default class CatalogueModule extends VuexModule {
	catalogueParentCategory = {};
	
	/**
	 * Get dynamic list object
	 *
	 */
	get getCatalogueParentCategory() {
		return this.catalogueParentCategory;
	}

	

	@Action({ rawError: true })
	async [Actions.GET_CATALOGUE_PARENT_CATEGORY](id) {
		if(id){
            const response = await ApiService.get(Endpoints.CATEGORIES + '/' + id, '');		
            this.context.commit(Mutations.SET_CATALOGUE_PARENT_CATEGORY, response.data.data);					
        }
        else{
            this.context.commit(Mutations.SET_CATALOGUE_PARENT_CATEGORY, {});					
        }
	}

	@Mutation
	[Mutations.SET_CATALOGUE_PARENT_CATEGORY](catalogueParentCategory) {
		this.catalogueParentCategory = { ...catalogueParentCategory };
	}
	
}
